import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import _isFunction from "lodash/isFunction";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.is-array.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Row, Col, Paper, Button, ExternalCreditDataForm } from 'components';
import { externalCreditStatusName, borrowerTypeName, currencyName, dateFormat2 } from 'enums';
import { list } from 'styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var ExternalCreditDetailsTab = function ExternalCreditDetailsTab(_ref) {
  var _ref4, _currencyName$externa, _externalCredit$numbe, _externalCredit$borro, _borrowerTypeName$ext, _externalCredit$borro2, _externalCreditStatus, _externalCredit$perio, _externalCredit$grati;

  var externalCredit = _ref.externalCredit,
      onExternalCreditChange = _ref.onExternalCreditChange;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isEdit = _useState2[0],
      setIsEdit = _useState2[1];

  var handleUpdate = function handleUpdate(data) {
    _isFunction(onExternalCreditChange) && onExternalCreditChange(data);
    setIsEdit(false);
  };

  var handleClose = function handleClose() {
    return setIsEdit(false);
  };

  var formatDate = function formatDate(date) {
    return moment(date).isValid() ? moment(date).format(dateFormat2) : '--';
  };

  var formatCurrency = function formatCurrency(value, currency) {
    var _ref2, _currencyName$currenc;

    return value !== null && value !== undefined ? "".concat(value, " ").concat((_ref2 = (_currencyName$currenc = currencyName[currency]) !== null && _currencyName$currenc !== void 0 ? _currencyName$currenc : currency) !== null && _ref2 !== void 0 ? _ref2 : '') : '--';
  };

  return ___EmotionJSX(Row, {
    justify: "space-between",
    align: "center",
    backgroundColor: "white"
  }, ___EmotionJSX(Col, {
    sm: 12
  }, ___EmotionJSX(Paper, {
    header: function header(_ref3) {
      var css = _ref3.css;
      return ___EmotionJSX("div", {
        css: css
      }, ___EmotionJSX("h5", null, "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u0437\u0430 \u0432\u044A\u043D\u0448\u043D\u0438\u044F \u043A\u0440\u0435\u0434\u0438\u0442"), !isEdit && ___EmotionJSX(Button, {
        small: true,
        onClick: function onClick() {
          return setIsEdit(function (prev) {
            return !prev;
          });
        }
      }, "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u0430\u0439"));
    },
    margin: "0 0 2em 0"
  }, isEdit ? ___EmotionJSX(ExternalCreditDataForm, {
    data: externalCredit,
    onSubmit: handleUpdate,
    onClose: handleClose
  }) : ___EmotionJSX("div", {
    css: list
  }, ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0412\u0430\u043B\u0443\u0442\u0430"), ___EmotionJSX("p", {
    className: "value"
  }, (_ref4 = (_currencyName$externa = currencyName[externalCredit === null || externalCredit === void 0 ? void 0 : externalCredit.currency]) !== null && _currencyName$externa !== void 0 ? _currencyName$externa : externalCredit === null || externalCredit === void 0 ? void 0 : externalCredit.currency) !== null && _ref4 !== void 0 ? _ref4 : '--')), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0412 \u0426\u041A\u0420"), ___EmotionJSX("p", {
    className: "value"
  }, externalCredit !== null && externalCredit !== void 0 && externalCredit.in_ckr ? 'ДА' : 'НЕ')), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0426\u0435\u0441\u0438\u044F"), ___EmotionJSX("p", {
    className: "value"
  }, externalCredit !== null && externalCredit !== void 0 && externalCredit.debt_assignment ? 'ДА' : 'НЕ')), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u041D\u043E\u043C\u0435\u0440"), ___EmotionJSX("p", {
    className: "value"
  }, (_externalCredit$numbe = externalCredit === null || externalCredit === void 0 ? void 0 : externalCredit.number) !== null && _externalCredit$numbe !== void 0 ? _externalCredit$numbe : '--')), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0418\u043C\u0435 \u043D\u0430 \u043A\u0440\u0435\u0434\u0438\u0442\u043E\u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044F"), ___EmotionJSX("p", {
    className: "value"
  }, (_externalCredit$borro = externalCredit === null || externalCredit === void 0 ? void 0 : externalCredit.borrower_name) !== null && _externalCredit$borro !== void 0 ? _externalCredit$borro : '--')), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0422\u0438\u043F \u043A\u0440\u0435\u0434\u0438\u0442\u043E\u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B"), ___EmotionJSX("p", {
    className: "value"
  }, (_borrowerTypeName$ext = borrowerTypeName[externalCredit === null || externalCredit === void 0 ? void 0 : externalCredit.borrower_type]) !== null && _borrowerTypeName$ext !== void 0 ? _borrowerTypeName$ext : '--')), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u043D\u0430 \u043A\u0440\u0435\u0434\u0438\u0442\u043E\u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044F"), ___EmotionJSX("p", {
    className: "value"
  }, (_externalCredit$borro2 = externalCredit === null || externalCredit === void 0 ? void 0 : externalCredit.borrower_identifier) !== null && _externalCredit$borro2 !== void 0 ? _externalCredit$borro2 : '--')), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0421\u0443\u043C\u0430"), ___EmotionJSX("p", {
    className: "value"
  }, formatCurrency(externalCredit === null || externalCredit === void 0 ? void 0 : externalCredit.amount, externalCredit === null || externalCredit === void 0 ? void 0 : externalCredit.currency))), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u041F\u043B\u0430\u0442\u0435\u043D\u043E"), ___EmotionJSX("p", {
    className: "value"
  }, formatCurrency(externalCredit === null || externalCredit === void 0 ? void 0 : externalCredit.payed, externalCredit === null || externalCredit === void 0 ? void 0 : externalCredit.currency))), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0421\u0442\u0430\u0442\u0443\u0441"), ___EmotionJSX("p", {
    className: "value"
  }, ___EmotionJSX("span", null, (_externalCreditStatus = externalCreditStatusName[externalCredit === null || externalCredit === void 0 ? void 0 : externalCredit.status]) !== null && _externalCreditStatus !== void 0 ? _externalCreditStatus : '--'))), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u041B\u0438\u0445\u0432\u0435\u043D \u043F\u0440\u043E\u0446\u0435\u043D\u0442"), ___EmotionJSX("p", {
    className: "value"
  }, (externalCredit === null || externalCredit === void 0 ? void 0 : externalCredit.interest_percent) !== null && (externalCredit === null || externalCredit === void 0 ? void 0 : externalCredit.interest_percent) !== undefined ? "".concat(externalCredit === null || externalCredit === void 0 ? void 0 : externalCredit.interest_percent, "%") : '--')), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u041F\u0435\u0440\u0438\u043E\u0434 (\u043C\u0435\u0441\u0435\u0446\u0438)"), ___EmotionJSX("p", {
    className: "value"
  }, (_externalCredit$perio = externalCredit === null || externalCredit === void 0 ? void 0 : externalCredit.period_months) !== null && _externalCredit$perio !== void 0 ? _externalCredit$perio : '--')), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0414\u0430\u0442\u0430"), ___EmotionJSX("p", {
    className: "value"
  }, formatDate(externalCredit === null || externalCredit === void 0 ? void 0 : externalCredit.date))), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0413\u0440\u0430\u0442\u0438\u0441\u0435\u043D \u043F\u0435\u0440\u0438\u043E\u0434"), ___EmotionJSX("p", {
    className: "value"
  }, (_externalCredit$grati = externalCredit === null || externalCredit === void 0 ? void 0 : externalCredit.gratis_period) !== null && _externalCredit$grati !== void 0 ? _externalCredit$grati : '--')), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0421\u043B\u0435\u0434\u0432\u0430\u0449\u0430 \u0434\u0430\u0442\u0430 \u043D\u0430 \u043F\u043B\u0430\u0449\u0430\u043D\u0435 \u043D\u0430 \u0433\u043B\u0430\u0432\u043D\u0438\u0446\u0430"), ___EmotionJSX("p", {
    className: "value"
  }, formatDate(externalCredit === null || externalCredit === void 0 ? void 0 : externalCredit.next_principal_payment_date))), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0421\u043B\u0435\u0434\u0432\u0430\u0449\u0430 \u0434\u0430\u0442\u0430 \u043D\u0430 \u043F\u043B\u0430\u0449\u0430\u043D\u0435 \u043D\u0430 \u043B\u0438\u0445\u0432\u0430"), ___EmotionJSX("p", {
    className: "value"
  }, formatDate(externalCredit === null || externalCredit === void 0 ? void 0 : externalCredit.next_interest_payment_date))), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0414\u0430\u0442\u0430 \u043D\u0430 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u043E \u043F\u043B\u0430\u0449\u0430\u043D\u0435"), ___EmotionJSX("p", {
    className: "value"
  }, formatDate(externalCredit === null || externalCredit === void 0 ? void 0 : externalCredit.last_payment_date))), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0421\u0443\u043C\u0430 \u043D\u0430 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u043E \u043F\u043B\u0430\u0449\u0430\u043D\u0435"), ___EmotionJSX("p", {
    className: "value"
  }, formatCurrency(externalCredit === null || externalCredit === void 0 ? void 0 : externalCredit.last_payment_amount, externalCredit === null || externalCredit === void 0 ? void 0 : externalCredit.currency))), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u041C\u0435\u0441\u0435\u0447\u043D\u0430 \u0432\u043D\u043E\u0441\u043A\u0430"), ___EmotionJSX("p", {
    className: "value"
  }, formatCurrency(externalCredit === null || externalCredit === void 0 ? void 0 : externalCredit.monthly_payment_amount, externalCredit === null || externalCredit === void 0 ? void 0 : externalCredit.currency))), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0411\u044A\u0434\u0435\u0449\u0430 \u043B\u0438\u0445\u0432\u0430"), ___EmotionJSX("p", {
    className: "value"
  }, formatCurrency(externalCredit === null || externalCredit === void 0 ? void 0 : externalCredit.future_interest, externalCredit === null || externalCredit === void 0 ? void 0 : externalCredit.currency))), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0413\u041F\u0420"), ___EmotionJSX("p", {
    className: "value"
  }, (externalCredit === null || externalCredit === void 0 ? void 0 : externalCredit.gpr) !== null && (externalCredit === null || externalCredit === void 0 ? void 0 : externalCredit.gpr) !== undefined ? "".concat(externalCredit === null || externalCredit === void 0 ? void 0 : externalCredit.gpr, "%") : '--'))))));
};

ExternalCreditDetailsTab.propTypes = {
  externalCredit: PropTypes.object,
  onExternalCreditChange: PropTypes.func
};
export default ExternalCreditDetailsTab;